var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpringData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.88 145.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6db33f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-data") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.33,101.79C29.54,101.79,17,99.42,0,95.46v44l.8.2c16.4,4,28.8,6.32,57.53,6.32s41.35-2.38,57.74-6.37l.81-.2v-44C99.93,99.4,87.27,101.79,58.33,101.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.33,0C29.6,0,17.2,2.36.8,6.32l-.8.2V53c17-4,29.54-6.33,58.33-6.33s41.6,2.39,58.55,6.39V6.57l-.81-.2C99.68,2.38,87.21,0,58.33,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.88,55.58l-.81-.2C99.68,51.39,87.21,49,58.33,49S17.2,51.37.8,55.32l-.8.2V92.94l.8.19c16.4,4,28.8,6.33,57.53,6.33s41.35-2.39,57.74-6.38l.81-.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringData);
export default __webpack_public_path__ + "static/media/spring-data.8fd5cda8729cd3ac8b5b20e548c8dafe.svg";
export { ForwardRef as ReactComponent };